import { Injectable } from "@angular/core";
import { Route, Router, UrlSegment } from "@angular/router";
import { AppService } from "./app.service";
import { environment } from "src/environments/environment";

@Injectable()
export class LoadGuard  {

    constructor(
        private service: AppService,
        private router: Router
    ) { }

    canMatch(route: Route, segments: UrlSegment[]): boolean
    {
        if (route?.data?.isCashRegister !== environment.isCashRegister)
            return false;

        return true;
    }
}
